import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import { baseURL } from '../../api/api';
import NoImage from "../../assets/images/noimages.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import translations from '../../shared/Translations';

function ProfileSettings() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);

  const [image,setImage] = useState("")

  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] || key;
  
   useEffect(() => {
      const savedLang = localStorage.getItem("lang");
      if (savedLang) setLang(savedLang);
    }, []);

  const [showOld, setShowOld] = useState(false);
const [showNew, setShowNew] = useState(false);

const [showConfirm, setShowConfirm] = useState(false);

useEffect(()=>{
    fetchUserSetting()
    AOS.init({
                  duration: 1000,  
                  once: false,    
                  mirror: true,    
                });
},[])


  const [form, setForm] = useState({
    user_name: "",
    phone: "",
    old_password: "",
    password: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleBackCustomer = () => {
    navigate("/dashboard");
  };

  const profileCreate = async (e) => {
    e.preventDefault();
    setSubmit(true);
    setLoading(true);

    const userData = {
  user_name: form.user_name,
  old_password: form.old_password,
  phone: form.phone
};

// ✅ only add password if user entered it
if (form.password && form.password.trim() !== "") {
  userData.password = form.password;
}

    const apiData = {
     userData
    };

    try {
      const responseData = await superAdminApis.profileSettingUpdateAPI(apiData);

      if (responseData.apiStatus?.code === '200') {
        toast.success(responseData.apiStatus.message || 'Profile Updated!');
        navigate('/');
      } else {
        toast.error(responseData.apiStatus?.message || 'Update failed!');
      }
    } catch (error) {
      console.error('Error during update:', error);
      toast.error('An error occurred.');
    } finally {
      setLoading(false);
    }
  };

   const fetchUserSetting = async () => {
      try {
        const res = await superAdminApis.profileGetAPI();
        if (res?.apiStatus?.code === 200 || res?.apiStatus?.code === "200") {
         const data = res.result
         setImage(data?.profileImage)
           setForm({
    user_name: data.user_name || "",
    phone: data.phone || "",
    old_password: "",
    password: ""
  });
        } else {
          toast.error("Failed to fetch user");
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch user");
      }
    };


               const handleUpload = async (file, existingImgId = null) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    // ✅ Include img_id if you want to update an existing image
    if (existingImgId) {
      formData.append("img_id", existingImgId);
    }

    try {
      const res = await superAdminApis.profileUpdateAPI(formData);

      if (res?.apiStatus?.code === 200 || res?.apiStatus?.code === "200") {
        toast.success("Profile uploaded successfully!");
      
        return res.responseData?.img_id?.toString() || "";
      } else {
        toast.error(res?.apiStatus?.message || "Upload failed");
        return "";
      }
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
      return "";
    }
  };



  return (
    <div>



<div className="d-flex justify-content-between align-items-center mt-3 mb-4">

  {/* Left side (Breadcrumb) */}
  <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
    <ol className="breadcrumb mb-0">
      <li className="breadcrumb-item">
        <a href="#" onClick={handleBackCustomer}> {t("dashboard")}</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
       {t("profileSettings")}
      </li>
    </ol>
  </nav>

  {/* Right side (Button) */}
  <div>
    <button className={`btn add-customer `} onClick={handleBackCustomer}>
      <i className="fa fa-arrow-left me-2"></i> {t("back")}
    </button>
  </div>

</div>

  <div className='customer-list-container card'>
     


{/* Form Field */}

  <form data-aos="fade-up" autoComplete='off' className='border-input-hover'>

          <div className={`row p-0 overlay-text mt-3 mb-3 ${lang === "ta" && "fs-tamil"}`}>
            <div className='col-md-2'>

  <div
  style={{
    width: "130px",
    height: "130px",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f0f0f0"
  }}
>
  <img
src={image?.altered_file_name 
      ? baseURL + image.path + image.altered_file_name 
      : NoImage}
    alt="Customer"
    style={{
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"  
    }}
  />
</div>

   
            </div>


            <div className='col-md-10'>
                <div className='row'>
    <div className="col-md-4">
              <div className="form-group">
                <label  className={`form-label ${lang === "ta" ? "fs-tamil" : ""}`}>  {t("userName")}</label>
                
                <input
                  type="text"
                  name="user_name"
                  value={form.user_name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <label className={`form-label ${lang === "ta" ? "fs-tamil" : ""}`}> {t("phone")}</label>
                <input
                  type="text"
                   onWheel={(e) => e.preventDefault()} 
                  maxLength="10"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

             <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">  {t("image")}</label>
                <input
                  type="file"
                  name="phone"
                  onChange={(e) => handleUpload(e.target.files[0])}
                  className="form-control"
                />
              </div>
            </div>

  <div className="col-md-6 mt-1">
  <div className="form-group">
    <label className="form-label"> {t("oldPassword")}</label>

    <div className="password-wrapper-setting">
      <input
        type={showOld ? "text" : "password"}
        name="old_password"
        value={form.old_password}
        onChange={handleChange}
        className="form-control"
      />

      <i
        className={`fa ${showOld ? "fa-eye" : "fa-eye-slash"} toggle-eye`}
        onClick={() => setShowOld(!showOld)}
      ></i>
    </div>
  </div>
</div>


           <div className="col-md-6 mt-1">
  <div className="form-group ">
    <label className="form-label"> {t("newPassword")}</label>
<div className='password-wrapper-setting'>
    <input
      type={showNew ? "text" : "password"}
      name="password"
      value={form.password}
      onChange={handleChange}
      className="form-control"
    />

    <i
      className={`fa ${showNew ? "fa-eye" : "fa-eye-slash"} toggle-eye`}
      onClick={() => setShowNew(!showNew)}
    ></i>

    </div>
  </div>
</div>


            <div className="text-end mt-3 text-center mb-3 all-btn-color">
              <button onClick={profileCreate} type="submit" className="btn add-customer" disabled={loading}>
                {loading ? t("updating") : t("submit")}
              </button>
            </div>
                </div>
            </div>


        

          </div>

        </form>



    </div>
    </div>
 
  )
}

export default ProfileSettings
